import React, { type FC } from 'react';
import css from '../TemplatePage.scss';
import { useTranslation } from '@wix/wix-i18n-config';
import { useSingleTemplateData } from '../../../hooks/useSingleTemplateData';
import { Button, Divider, Heading, Text } from '@wix/design-system';
import { DataHooks } from '../../../constants/dataHooks';

export const HowToBuild: FC = () => {
  const { t } = useTranslation();
  const { template } = useSingleTemplateData();
  const buildDocUrl = template?.buildDocUrl;

  if (!buildDocUrl) {
    return null;
  }

  return (
    <>
      <div className={css.divider}>
        <Divider skin="light" />
      </div>
      <div
        data-hook={DataHooks.HowToBuildWrapper}
        className={css.howToBuildWrapper}
      >
        <Heading dataHook={DataHooks.HowToBuildTitle} size="large">
          {t('app.template-page.how-to-build.title')}
        </Heading>
        <Text>{t('app.template-page.how-to-build.subtitle')}</Text>
        <Button
          dataHook={DataHooks.HowToBuildDocsButton}
          className={css.howToBuildButton}
          onClick={() => window.open(buildDocUrl!)}
        >
          {t('app.template-page.how-to-build.button.learn-how')}
        </Button>
      </div>
    </>
  );
};
